export default __webpack_public_path__ + "static/media/down.bc88679a.svg";